/**
 * Generated by orval 🍺
 * Do not edit manually.
 * Sara API
 * Sara AI Video Interviewer API
 * OpenAPI spec version: 1.0
 */
import {
  useQuery
} from '@tanstack/react-query';
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseQueryOptions,
  UseQueryResult
} from '@tanstack/react-query';

import type {
  AdminInterviewTypeDto,
  AdminInterviewTypeVersionDto,
  AdminOrganizationDto
} from '../model';

import { customFetch } from '../../client';


type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];



const withQueryKey = <T extends object, K>(query: T, queryKey: K): T & { queryKey: K } => {
  const result = { queryKey } as T & { queryKey: K };
  for (const key of Object.keys(query)) {
    // The explicit queryKey always wins, matching the previous
    // `{ ...query, queryKey }` spread where it was set last.
    if (key === 'queryKey') continue;
    Object.defineProperty(result, key, {
      enumerable: true,
      configurable: true,
      get: () => (query as Record<string, unknown>)[key],
    });
  }
  return result;
};

export const getListAdminOrganizationsUrl = () => {




  return `/admin/organizations`
}

export const listAdminOrganizations = async ( options?: Parameters<typeof customFetch>[1]): Promise<AdminOrganizationDto[]> => {

  return customFetch<AdminOrganizationDto[]>(getListAdminOrganizationsUrl(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getListAdminOrganizationsQueryKey = () => {
    return [
    `/admin/organizations`
    ] as const;
    }


export const getListAdminOrganizationsQueryOptions = <TData = Awaited<ReturnType<typeof listAdminOrganizations>>, TError = unknown>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listAdminOrganizations>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListAdminOrganizationsQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listAdminOrganizations>>> = ({ signal }) => listAdminOrganizations({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listAdminOrganizations>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ListAdminOrganizationsQueryResult = NonNullable<Awaited<ReturnType<typeof listAdminOrganizations>>>
export type ListAdminOrganizationsQueryError = unknown


export function useListAdminOrganizations<TData = Awaited<ReturnType<typeof listAdminOrganizations>>, TError = unknown>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof listAdminOrganizations>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof listAdminOrganizations>>,
          TError,
          Awaited<ReturnType<typeof listAdminOrganizations>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListAdminOrganizations<TData = Awaited<ReturnType<typeof listAdminOrganizations>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listAdminOrganizations>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof listAdminOrganizations>>,
          TError,
          Awaited<ReturnType<typeof listAdminOrganizations>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListAdminOrganizations<TData = Awaited<ReturnType<typeof listAdminOrganizations>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listAdminOrganizations>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useListAdminOrganizations<TData = Awaited<ReturnType<typeof listAdminOrganizations>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listAdminOrganizations>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getListAdminOrganizationsQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getListAdminInterviewTypesUrl = (orgId: string,) => {




  return `/admin/organizations/${orgId}/interview-types`
}

export const listAdminInterviewTypes = async (orgId: string, options?: Parameters<typeof customFetch>[1]): Promise<AdminInterviewTypeDto[]> => {

  return customFetch<AdminInterviewTypeDto[]>(getListAdminInterviewTypesUrl(orgId),
  {
    ...options,
    method: 'GET'


  }
);}





export const getListAdminInterviewTypesQueryKey = (orgId: string,) => {
    return [
    `/admin/organizations/${orgId}/interview-types`
    ] as const;
    }


export const getListAdminInterviewTypesQueryOptions = <TData = Awaited<ReturnType<typeof listAdminInterviewTypes>>, TError = unknown>(orgId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listAdminInterviewTypes>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListAdminInterviewTypesQueryKey(orgId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listAdminInterviewTypes>>> = ({ signal }) => listAdminInterviewTypes(orgId, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: orgId !== null && orgId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listAdminInterviewTypes>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ListAdminInterviewTypesQueryResult = NonNullable<Awaited<ReturnType<typeof listAdminInterviewTypes>>>
export type ListAdminInterviewTypesQueryError = unknown


export function useListAdminInterviewTypes<TData = Awaited<ReturnType<typeof listAdminInterviewTypes>>, TError = unknown>(
 orgId: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof listAdminInterviewTypes>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof listAdminInterviewTypes>>,
          TError,
          Awaited<ReturnType<typeof listAdminInterviewTypes>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListAdminInterviewTypes<TData = Awaited<ReturnType<typeof listAdminInterviewTypes>>, TError = unknown>(
 orgId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listAdminInterviewTypes>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof listAdminInterviewTypes>>,
          TError,
          Awaited<ReturnType<typeof listAdminInterviewTypes>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListAdminInterviewTypes<TData = Awaited<ReturnType<typeof listAdminInterviewTypes>>, TError = unknown>(
 orgId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listAdminInterviewTypes>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useListAdminInterviewTypes<TData = Awaited<ReturnType<typeof listAdminInterviewTypes>>, TError = unknown>(
 orgId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listAdminInterviewTypes>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getListAdminInterviewTypesQueryOptions(orgId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getListAdminInterviewTypeVersionsUrl = (interviewTypeId: string,) => {




  return `/admin/interview-types/${interviewTypeId}/versions`
}

export const listAdminInterviewTypeVersions = async (interviewTypeId: string, options?: Parameters<typeof customFetch>[1]): Promise<AdminInterviewTypeVersionDto[]> => {

  return customFetch<AdminInterviewTypeVersionDto[]>(getListAdminInterviewTypeVersionsUrl(interviewTypeId),
  {
    ...options,
    method: 'GET'


  }
);}





export const getListAdminInterviewTypeVersionsQueryKey = (interviewTypeId: string,) => {
    return [
    `/admin/interview-types/${interviewTypeId}/versions`
    ] as const;
    }


export const getListAdminInterviewTypeVersionsQueryOptions = <TData = Awaited<ReturnType<typeof listAdminInterviewTypeVersions>>, TError = unknown>(interviewTypeId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listAdminInterviewTypeVersions>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListAdminInterviewTypeVersionsQueryKey(interviewTypeId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listAdminInterviewTypeVersions>>> = ({ signal }) => listAdminInterviewTypeVersions(interviewTypeId, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: interviewTypeId !== null && interviewTypeId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listAdminInterviewTypeVersions>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ListAdminInterviewTypeVersionsQueryResult = NonNullable<Awaited<ReturnType<typeof listAdminInterviewTypeVersions>>>
export type ListAdminInterviewTypeVersionsQueryError = unknown


export function useListAdminInterviewTypeVersions<TData = Awaited<ReturnType<typeof listAdminInterviewTypeVersions>>, TError = unknown>(
 interviewTypeId: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof listAdminInterviewTypeVersions>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof listAdminInterviewTypeVersions>>,
          TError,
          Awaited<ReturnType<typeof listAdminInterviewTypeVersions>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListAdminInterviewTypeVersions<TData = Awaited<ReturnType<typeof listAdminInterviewTypeVersions>>, TError = unknown>(
 interviewTypeId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listAdminInterviewTypeVersions>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof listAdminInterviewTypeVersions>>,
          TError,
          Awaited<ReturnType<typeof listAdminInterviewTypeVersions>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListAdminInterviewTypeVersions<TData = Awaited<ReturnType<typeof listAdminInterviewTypeVersions>>, TError = unknown>(
 interviewTypeId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listAdminInterviewTypeVersions>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useListAdminInterviewTypeVersions<TData = Awaited<ReturnType<typeof listAdminInterviewTypeVersions>>, TError = unknown>(
 interviewTypeId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listAdminInterviewTypeVersions>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getListAdminInterviewTypeVersionsQueryOptions(interviewTypeId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






